export const localization = {
  pt: {
    preProcessingTag: 'Pré-processamento',
    preProcessingsTitle: 'Pré-processamentos',
    optimization: {
      title: 'Otimização',
      description: 'Remove ruídos e padroniza o texto para respostas mais limpas e rápidas. Recomendado para quase todos os tipos de bases.',
    },
    indexing: {
      title: 'Indexação',
      description: 'Adiciona resumos e palavras-chave, facilitando a busca por tópicos específicos. Ideal para conteúdos segmentados como FAQs, tabelas e artigos curtos.',
    },
    contextualization: {
      title: 'Contextualização',
      description: 'Identifica a função de cada trecho no contexto geral do documento, agindo como um GPS para a busca. Ideal para documentos longos e manuais.',
    },
    usesAi: 'Utiliza IA',
    indexingContextualizationWarning: 'Atenção: Usar Indexação e Contextualização juntas pode gerar dados redundantes e aumentar custos sem ganho real de precisão.',
  },
  en: {
    preProcessingTag: 'Pre-processing',
    preProcessingsTitle: 'Pre-processings',
    optimization: {
      title: 'Optimization',
      description: 'Removes noise and standardizes text for cleaner and faster responses. Recommended for almost all types of bases.',
    },
    indexing: {
      title: 'Indexing',
      description: 'Adds summaries and keywords, making it easier to search for specific topics. Ideal for segmented content like FAQs, tables, and short articles.',
    },
    contextualization: {
      title: 'Contextualization',
      description: 'Identifies the role of each section in the overall document context, acting like a GPS for search. Ideal for long documents and manuals.',
    },
    usesAi: 'Uses AI',
    indexingContextualizationWarning: 'Warning: Using Indexing and Contextualization together can generate redundant data and increase costs without real precision gains.',
  },
  es: {
    preProcessingTag: 'Preprocesamiento',
    preProcessingsTitle: 'Preprocesamientos',
    optimization: {
      title: 'Optimización',
      description: 'Elimina ruidos y estandariza el texto para respuestas más limpias y rápidas. Recomendado para casi todos los tipos de bases.',
    },
    indexing: {
      title: 'Indexación',
      description: 'Agrega resúmenes y palabras clave, facilitando la búsqueda de temas específicos. Ideal para contenidos segmentados como FAQs, tablas y artículos cortos.',
    },
    contextualization: {
      title: 'Contextualización',
      description: 'Identifica la función de cada fragmento en el contexto general del documento, actuando como un GPS para la búsqueda. Ideal para documentos largos y manuales.',
    },
    usesAi: 'Usa IA',
    indexingContextualizationWarning: 'Atención: Usar Indexación y Contextualización juntas puede generar datos redundantes y aumentar costos sin ganancia real de precisión.',
  },
};
